import {
  ADD_INFO,
  EDIT_INFO,
  GET_INFOS,
  GET_INFO_BY_ID,
  REMOVE_INFO,
} from "../actions/site-info-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const infoReducer = (state = initialState, action: any): ApiRequestState => {
  switch (action.type) {
    case (ADD_INFO.REQUEST,
    GET_INFOS.REQUEST,
    GET_INFO_BY_ID.REQUEST,
    EDIT_INFO.REQUEST,
    REMOVE_INFO.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_INFO.SUCCESS,
    GET_INFOS.SUCCESS,
    GET_INFO_BY_ID.SUCCESS,
    EDIT_INFO.SUCCESS,
    REMOVE_INFO.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_INFO.FAILURE,
    GET_INFOS.FAILURE,
    GET_INFO_BY_ID.FAILURE,
    EDIT_INFO.FAILURE,
    REMOVE_INFO.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { infoReducer };
